import { connect } from 'react-redux';
import RestrictedRolesRoute from './RestrictedRolesRoute';

const mapStateToProps = ({ profile, auth }) => ({
  signedIn: auth.signedIn,
  userRoles: profile.user ? profile.user.roles : undefined,
});

export default connect(mapStateToProps)(RestrictedRolesRoute);
